function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "personal_opinions");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M271.57105,717.132l-2.27009-8.95369a116.26686,116.26686,0,0,0-12.33507-4.42545l-.28664,4.16115-1.16227-4.58431c-5.1983-1.48439-8.73471-2.13824-8.73471-2.13824s4.77687,18.16495,14.796,32.05229l11.67448,2.05069-9.06958,1.30767a47.03847,47.03847,0,0,0,4.05695,4.29933c14.575,13.52871,30.80881,19.73576,36.25923,13.86381s-1.94652-21.59928-16.52152-35.128a61.9275,61.9275,0,0,0-15.87616-10.20857Z",
  transform: "translate(-156.48273 -134.70243)",
  fill: "#e6e6e6"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M293.16144,707.40846l2.68487-8.83818a116.26325,116.26325,0,0,0-8.27186-10.1644l-2.39627,3.414,1.37468-4.52516c-3.6827-3.95771-6.37205-6.3454-6.37205-6.3454s-5.30027,18.01918-3.90183,35.08626l8.93387,7.79-8.4399-3.56865a47.0373,47.0373,0,0,0,1.25061,5.77746c5.48384,19.115,16.17227,32.81982,23.8733,30.6105s9.49839-19.49612,4.01455-38.61115a61.92735,61.92735,0,0,0-8.31388-16.9454Z",
  transform: "translate(-156.48273 -134.70243)",
  fill: "#e6e6e6"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M455.45658,714.95691l-2.13363-8.41546a109.27662,109.27662,0,0,0-11.59358-4.15942l-.2694,3.911-1.09241-4.30873c-4.88581-1.39516-8.20963-2.0097-8.20963-2.0097s4.48971,17.073,13.90656,30.12552l10.97269,1.92742-8.52438,1.22906a44.21037,44.21037,0,0,0,3.81308,4.04088c13.69885,12.71547,28.95679,18.54939,34.07958,13.03042S484.576,730.027,470.8771,717.31156a58.20488,58.20488,0,0,0-14.9218-9.5949Z",
  transform: "translate(-156.48273 -134.70243)",
  fill: "#e6e6e6"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M475.7491,705.81791l2.52348-8.30688a109.27565,109.27565,0,0,0-7.77461-9.55338l-2.25223,3.20873,1.292-4.25313c-3.46132-3.7198-5.989-5.964-5.989-5.964s-4.98166,16.936-3.66728,32.97712l8.39683,7.32176-7.93256-3.35414a44.21185,44.21185,0,0,0,1.17543,5.43017c5.15419,17.966,15.20011,30.84691,22.43821,28.7704s8.92742-18.32414,3.77323-36.29011a58.20529,58.20529,0,0,0-7.81411-15.92676Z",
  transform: "translate(-156.48273 -134.70243)",
  fill: "#e6e6e6"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M813.83264,719.48987l-1.07518-4.24068a55.06638,55.06638,0,0,0-5.84218-2.096l-.13576,1.97082-.55048-2.17124c-2.462-.703-4.137-1.01272-4.137-1.01272a52.77327,52.77327,0,0,0,7.00773,15.18073l5.52932.97126-4.29557.61934a22.27725,22.27725,0,0,0,1.92147,2.03627c6.90307,6.40752,14.59178,9.34733,17.17324,6.56623s-.92192-10.22994-7.825-16.63746a29.33029,29.33029,0,0,0-7.51933-4.835Z",
  transform: "translate(-156.48273 -134.70243)",
  fill: "#e6e6e6"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M824.05836,714.88459l1.27162-4.186a55.06515,55.06515,0,0,0-3.91775-4.8141l-1.13493,1.61693.65108-2.14322c-1.74422-1.87447-3.01795-3.00534-3.01795-3.00534a52.77326,52.77326,0,0,0-1.848,16.6177l4.2313,3.68955-3.99734-1.69021a22.27782,22.27782,0,0,0,.59232,2.73635c2.59727,9.05333,7.65957,15.54425,11.307,14.49786s4.49867-9.23382,1.90139-18.28716a29.33056,29.33056,0,0,0-3.93765-8.02575Z",
  transform: "translate(-156.48273 -134.70243)",
  fill: "#e6e6e6"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M906.48773,712.1637l-1.41419-5.57786a72.42864,72.42864,0,0,0-7.68435-2.75691l-.17857,2.59225-.72406-2.85587c-3.23837-.92473-5.44143-1.332-5.44143-1.332s2.97583,11.31617,9.21742,19.96754l7.27283,1.27751-5.65006.81464a29.30308,29.30308,0,0,0,2.52735,2.67834c9.07976,8.428,19.19289,12.29475,22.58833,8.63671s-1.21261-13.45566-10.29237-21.88361a38.5788,38.5788,0,0,0-9.89034-6.35961Z",
  transform: "translate(-156.48273 -134.70243)",
  fill: "#e6e6e6"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M919.93785,706.10627l1.67259-5.5059a72.43067,72.43067,0,0,0-5.1531-6.33209l-1.4928,2.12679.85637-2.819c-2.2942-2.46553-3.96957-3.953-3.96957-3.953s-3.3019,11.22537-2.43072,21.85761l5.56552,4.85295-5.25779-2.22316a29.30372,29.30372,0,0,0,.77909,3.59917c3.41625,11.90805,10.0748,20.44569,14.87229,19.06935s5.9172-12.14545,2.50094-24.0535a38.579,38.579,0,0,0-5.17928-10.55644Z",
  transform: "translate(-156.48273 -134.70243)",
  fill: "#e6e6e6"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M730.69312,689.93721l6.42488-7.44863a123.81522,123.81522,0,0,0-3.67246-13.4639l-3.80526,2.29122,3.28956-3.81369c-1.8797-5.44158-3.469-8.92607-3.469-8.92607s-12.92992,15.261-18.92647,32.483l5.34076,11.43729-6.67976-7.11375a50.0915,50.0915,0,0,0-1.27312,6.165c-2.90134,20.97756,1.59786,38.9308,10.04926,40.09969s17.6546-14.88922,20.55594-35.86678a65.94849,65.94849,0,0,0-.78982-20.085Z",
  transform: "translate(-156.48273 -134.70243)",
  fill: "#e6e6e6"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M752.3616,702.8345l9.35019-3.05533a123.81457,123.81457,0,0,0,3.81572-13.424l-4.44181-.00556,4.78731-1.56431c1.20365-5.62985,1.64426-9.43427,1.64426-9.43427s-18.957,6.38064-32.99242,18.02381l-1.34,12.55149-2.04107-9.54247a50.09265,50.09265,0,0,0-4.27654,4.61943c-13.327,16.458-18.75555,34.15245-12.125,39.52161s22.80939-3.62015,36.1364-20.07818a65.9488,65.9488,0,0,0,9.70586-17.60194Z",
  transform: "translate(-156.48273 -134.70243)",
  fill: "#e6e6e6"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M839.006,719.53388l2.85745-3.31275a55.06348,55.06348,0,0,0-1.63332-5.988l-1.69238,1.019,1.463-1.69613c-.836-2.42013-1.54284-3.96985-1.54284-3.96985a52.77337,52.77337,0,0,0-8.41751,14.44675l2.3753,5.08671-2.97082-3.16383a22.28146,22.28146,0,0,0-.56621,2.74187c-1.29036,9.32972.71064,17.31438,4.46938,17.83424s7.85184-6.62194,9.14221-15.95166a29.33023,29.33023,0,0,0-.35127-8.93277Z",
  transform: "translate(-156.48273 -134.70243)",
  fill: "#e6e6e6"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M848.643,725.26992l4.15847-1.35885a55.06516,55.06516,0,0,0,1.697-5.97029l-1.97548-.00247,2.12915-.69573c.53532-2.50386.73128-4.19586.73128-4.19586a52.77324,52.77324,0,0,0-14.67331,8.016l-.596,5.58225-.90776-4.244a22.279,22.279,0,0,0-1.902,2.05448c-5.92715,7.31967-8.34149,15.18922-5.39255,17.57714s10.14442-1.61005,16.07158-8.92972a29.33054,29.33054,0,0,0,4.31665-7.82842Z",
  transform: "translate(-156.48273 -134.70243)",
  fill: "#e6e6e6"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M157.01727,765.29757s698.5-72,886.5,0Z",
  transform: "translate(-156.48273 -134.70243)",
  fill: "#e6e6e6"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M1043.51727,325.99665c-1.36853-106.02057-55.45523-191.29422-121.98376-191.29422-39.98052,0-75.46914,30.79621-97.72353,78.38336l26.16513,65.65082-36.16045-40.46534c-9.12083,27.38039-14.29739,58.64042-14.29739,91.84057a299.419,299.419,0,0,0,9.22321,74.62975L878.86219,393.437l-62.75478,35.09086c20.44452,56.0499,57.81184,94.331,100.883,96.85659l-8.30069,225.821,25.68761.91744-5.49065-226.965c61.33336-5.84083,110.46361-84.22975,114.39917-182.33134l-42.38442-23.70019Z",
  transform: "translate(-156.48273 -134.70243)",
  fill: "#e6e6e6"
});

var _ref17 = /*#__PURE__*/React.createElement("polygon", {
  points: "442.83 184.86 476.584 190.797 487.836 134.4 460.645 122.527 442.83 184.86",
  fill: "#2f2e41"
});

var _ref18 = /*#__PURE__*/React.createElement("polygon", {
  points: "483.418 193.88 517.172 199.816 528.423 143.42 501.233 131.547 483.418 193.88",
  fill: "#2f2e41"
});

var _ref19 = /*#__PURE__*/React.createElement("polygon", {
  points: "523.631 556.815 523.631 580.265 540.768 580.265 538.964 557.717 523.631 556.815",
  fill: "#a0616a"
});

var _ref20 = /*#__PURE__*/React.createElement("polygon", {
  points: "434.338 556.815 434.338 580.265 417.201 580.265 419.005 557.717 434.338 556.815",
  fill: "#a0616a"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M597.1345,474.14781l-13.70222,83.5183a498.77424,498.77424,0,0,0-6.30777,64.27106l-2.53869,76.79546,18.03894-1.80389L606.154,609.43987S641.32991,479.55949,653.95716,505.716s18.94089,109.1356,18.94089,109.1356l5.41169,81.17523h19.84283l1.8039-106.42975s10.82336-148.82127-16.235-161.44853Z",
  transform: "translate(-156.48273 -134.70243)",
  fill: "#2f2e41"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M699.05452,711.35989s-19.84284-13.5292-21.64673-2.70584l-7.21558,26.15647s-10.82336,20.74478,12.62726,20.74478,16.23505-15.3331,16.23505-15.3331Z",
  transform: "translate(-156.48273 -134.70243)",
  fill: "#2f2e41"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M571.88,711.35989s19.84284-13.5292,21.64673-2.70584l7.21558,26.15647S611.56565,755.5553,588.115,755.5553s-16.235-15.3331-16.235-15.3331Z",
  transform: "translate(-156.48273 -134.70243)",
  fill: "#2f2e41"
});

var _ref24 = /*#__PURE__*/React.createElement("circle", {
  cx: 490.70984,
  cy: 146.87967,
  r: 26.15647,
  fill: "#a0616a"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M630.50654,292.85644s2.70584,25.25452-10.82336,30.6662l22.54867,27.05842,29.76426-20.74479s-21.64673-4.50973-18.03895-17.137,3.60779-14.43115,3.60779-14.43115Z",
  transform: "translate(-156.48273 -134.70243)",
  fill: "#a0616a"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M624.64388,320.36583S643.58477,334.797,647.19256,333.895s10.82337-10.82337,10.82337-10.82337,26.60744.451,37.4308,7.66655-10.37239,51.862-10.37239,51.862,5.86266,20.29381-1.35292,25.70549,1.80389,18.94089,1.80389,18.94089-18.03894,33.372-65.84213,45.9993c0,0-29.76426,11.72531-28.86231,5.41168s9.92142-78.46939,9.92142-78.46939V325.32654Z",
  transform: "translate(-156.48273 -134.70243)",
  fill: "#575a89"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M624.6286,250.48981S610.969,255.043,610.27544,273.02452a31.894,31.894,0,0,0,.94815,8.5385c.76914,3.25966,1.26359,10.27343-4.69717,19.439a192.42262,192.42262,0,0,0-10.92123,18.786l-.04273.08546,15.00188,1.87523,3.18989-24.86669a123.8266,123.8266,0,0,1,9.83293-34.9093l.10382-.23152s6.56332,12.189,19.69,12.189l-4.68808-4.68809s20.62758,8.43856,28.12852,8.43856c0,0,5.6257,3.75047,0,9.37617s-16.87712,18.75235-10.3138,29.06614.93762,13.12664.93762,13.12664L667.759,323.624l4.68809-2.81285v3.75047l24.378-2.81286s6.56332-.93761-7.50094-16.87711c0,0-3.7139-6.18983-2.089-11.52847a26.92868,26.92868,0,0,0,1.02361-12.59362C685.108,263.17225,672.74617,228.22645,624.6286,250.48981Z",
  transform: "translate(-156.48273 -134.70243)",
  fill: "#2f2e41"
});

var _ref28 = /*#__PURE__*/React.createElement("polygon", {
  points: "365.556 341.7 611.035 341.7 611.035 477.762 579.854 477.762 579.854 515.179 546.263 477.762 365.556 477.762 365.556 341.7",
  fill: "#cd5c5c"
});

var _ref29 = /*#__PURE__*/React.createElement("rect", {
  x: 562.29022,
  y: 516.37093,
  width: 164.97534,
  height: 7.37003,
  transform: "translate(1133.07305 905.40946) rotate(-180)",
  fill: "#fff"
});

var _ref30 = /*#__PURE__*/React.createElement("rect", {
  x: 562.29022,
  y: 540.74873,
  width: 164.97534,
  height: 7.37003,
  transform: "translate(1133.07305 954.16506) rotate(-180)",
  fill: "#fff"
});

var _ref31 = /*#__PURE__*/React.createElement("rect", {
  x: 562.29022,
  y: 565.12653,
  width: 164.97534,
  height: 7.37003,
  transform: "translate(1133.07305 1002.92066) rotate(-180)",
  fill: "#fff"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M581.8014,397.48231l2.70584,19.84283,19.84283,55.01877s4.50974,42.39152,15.33311,36.97984-1.8039-43.29346-1.8039-43.29346l-16.235-51.411.902-18.03894Z",
  transform: "translate(-156.48273 -134.70243)",
  fill: "#a0616a"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M611.56565,327.13043l-8.13533-2.65274-3.59,1.7508s-12.62726.90194-14.43115,9.92141-8.11753,64.94019-8.11753,64.94019l33.372,1.8039Z",
  transform: "translate(-156.48273 -134.70243)",
  fill: "#575a89"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M702.21133,397.48231l-2.70584,19.84283-19.84283,55.01877s-4.50974,42.39152-15.3331,36.97984,1.80389-43.29346,1.80389-43.29346l16.23505-51.411-.902-18.03894Z",
  transform: "translate(-156.48273 -134.70243)",
  fill: "#a0616a"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M672.44708,327.13043l4.338-1.41451a9.87153,9.87153,0,0,1,7.38734.51256h0s12.62726.90194,14.43116,9.92141,8.11752,64.94019,8.11752,64.94019l-33.372,1.8039Z",
  transform: "translate(-156.48273 -134.70243)",
  fill: "#575a89"
});

var _ref36 = /*#__PURE__*/React.createElement("polygon", {
  points: "332.9 17.333 0 17.333 0 201.851 42.285 201.851 42.285 252.593 87.838 201.851 332.9 201.851 332.9 17.333",
  fill: "#cd5c5c"
});

var _ref37 = /*#__PURE__*/React.createElement("rect", {
  x: 54.58637,
  y: 71.53544,
  width: 223.72723,
  height: 9.99469,
  fill: "#fff"
});

var _ref38 = /*#__PURE__*/React.createElement("rect", {
  x: 54.58637,
  y: 104.59479,
  width: 223.72723,
  height: 9.99469,
  fill: "#fff"
});

var _ref39 = /*#__PURE__*/React.createElement("rect", {
  x: 54.58637,
  y: 137.65414,
  width: 223.72723,
  height: 9.99469,
  fill: "#fff"
});

var _ref40 = /*#__PURE__*/React.createElement("circle", {
  cx: 36.03455,
  cy: 267.42375,
  r: 9,
  fill: "#e6e6e6"
});

var SvgForesvg = function SvgForesvg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b7c7232a-1587-4d3b-a231-6a0b0f3ca05b",
    "data-name": "Layer 1",
    width: 887.03455,
    height: 630.59514,
    viewBox: "0 0 887.03455 630.59514",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgForesvg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fore.svg.a16482e0.svg";
export { ForwardRef as ReactComponent };